const rawBackendUrl = process.env.REACT_APP_BACKEND_URL?.trim();

if (!rawBackendUrl) {
  throw new Error("REACT_APP_BACKEND_URL is required. Configure it in Cloudflare Pages before building.");
}

let backendUrl;
try {
  backendUrl = new URL(rawBackendUrl);
} catch {
  throw new Error("REACT_APP_BACKEND_URL must be a valid absolute URL.");
}

if (process.env.NODE_ENV === "production" && backendUrl.protocol !== "https:") {
  throw new Error("REACT_APP_BACKEND_URL must use HTTPS in production.");
}

export const runtimeConfig = Object.freeze({
  backendUrl: backendUrl.toString().replace(/\/$/, ""),
  turnstileSiteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY?.trim() || "",
  publicSiteUrl: process.env.REACT_APP_PUBLIC_SITE_URL?.trim() || window.location.origin,
});
